import { FirestoreQueryBuilder } from '../../../../lib/gcp/builder/firestore-query.builder';
import { IRepository } from '../../../../utility/repository/repository';
import { Observable } from 'rxjs';
import { SlackOAuth } from '../entity';
import { SlackOAuthId } from '../value';

export abstract class ISlackOAuthRepository extends IRepository<SlackOAuthId, SlackOAuth> {
  abstract selectAll(builder: FirestoreQueryBuilder<SlackOAuth>): Observable<SlackOAuth>;
}
